import { Link, useNavigate, useParams } from "react-router-dom";
import patient from "../../../assets/img/patient.jpg";
import React, { useEffect, useRef, useState } from "react";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { ToastContainer } from "react-toastify";
import Textarea from "../../../components/text-area";
import { prompts } from "../../../util/dummyJson";
import {
  ADMINPROMPTS,
  DIAGONASTIC_TOOL,
  PRACTICE_FRAMEWORK,
} from "../../../action/apiPath";
import { CallWithAuth } from "../../../action/apiActions";
import { showToast } from "../../../util/toastHelper";
import AdminPromptsPageAddOrEdit from "./components/addEdit";

const MySwal = withReactContent(Swal);

/**
 * The Patient Relatives Information Page component
 * @returns {JSX.Element} The component
 */
const AdminPromptsPageAdd = () => {
  const { id } = useParams();
  const [isEditvalue, setIsEditValue] = React.useState(false);
  React.useEffect(() => {
    if (id) setIsEditValue(true);
  }, [id]);

  return (
    <>
      <div>
        <section className="site_hero patient_management_banner">
          <div className="site_container">
            <div className="site_row">
              <div className="txt_colm">
                <div className="txt_block">
                  <h1>{id ? "Update Prompts" : "Add Prompts"}</h1>
                </div>
              </div>
              <div className="img_colm">
                <div className="img_block">
                  {/* <img src={patient} alt="" /> */}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* <section class="create_account_block">
          <div class="site_container">
            <div class="create_account_form">
              <div class="field_block">
                <label for="">Select Role</label>
                <div class="input_check_grp">
                  <div class="item">
                    <input
                      type="radio"
                      name="dr_role"
                      value="psychiatrist"
                      checked={formData?.dr_role === "psychiatrist"}
                      onChange={handleRoleChange}
                    />
                    <span>psychiatrist </span>
                  </div>
                  <div class="item">
                    <input
                      type="radio"
                      name="dr_role"
                      value="psychologist"
                      checked={formData?.dr_role === "psychologist"}
                      onChange={handleRoleChange}
                    />
                    <span>psychologist </span>
                  </div>
                </div>
              </div>

              <div className="field_block">
                <label>Select Practice Framework</label>
                <select
                  name="practice_framework"
                  id="practice_framework"
                  onChange={handleFrameworkChange}
                  value={formData?.practiceFrameworkId || ""}
                >
                  <option value="">Select Practice Framework</option>
                  {practiceFrameworks?.map((framework) => (
                    <option key={framework.id} value={framework.id}>
                      {framework.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="field_block">
                <label>Select Provisional Diagnostic Tool</label>
                <select
                  name="diagnostic_tool"
                  id="diagnostic_tool"
                  onChange={handleDiagnosticToolChange}
                  value={formData?.diagnosticToolId || ""}
                >
                  <option value="">Select Diagnostic Tool</option>
                  {diagnostic_tool?.map((tool) => (
                    <option key={tool.id} value={tool.id}>
                      {tool.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="field_block">
                <label>Select Api endPoint</label>
                <select
                  name="apiEndpointName"
                  id="apiEndpointName"
                  onChange={handleApiEndpointChange}
                  value={formData?.apiEndpointName || ""}
                >
                  <option value="">Select Api Endpoint Name</option>
                  {apiEndpointNameList?.map((tool) => (
                    <option key={tool.value} value={tool.value}>
                      {tool.level}
                    </option>
                  ))}
                </select>
              </div>
              <div className="field_block">
                <label>Prompt Text</label>
                <Textarea
                  name="promtText"
                  value={formData?.promtText}
                  onChange={handleChange}
                  //   fieldName="background info"
                />
              </div>

              <button onClick={savePrompts} className="button_save_prompts">
                Save Prompts
              </button>
            </div>
          </div>
        </section> */}
        <AdminPromptsPageAddOrEdit isEdit={isEditvalue} />
        {/* <section className="site_container">
          <div className="row mx-auto mt-5">
            <div className="col-12 prompts_inner_block">
              <Textarea
                name="background_info"
                value={prompt.background_info}
                onChange={handleChange}
                fieldName="background info"
              />
            </div>

            
            <button onClick={savePrompts} className="button_save_prompts mt-5">
              Save Prompts
            </button>
          </div>
        </section> */}
      </div>
      <ToastContainer />
    </>
  );
};
export default AdminPromptsPageAdd;
